module.exports = __webpack_public_path__ + "img/Securitylogo.85f980f1.png";